import { Environment } from './environments'

export const WebAppUrls = {
  [Environment.Localhost]: 'http://localhost:5173',
  [Environment.Development]: 'https://devwallet.xpaid.org',
  [Environment.Staging]: 'https://stagewallet.xpaid.org',
  [Environment.Production]: 'https://wallet.xpaid.org',
}
